import StoreSettingsPage from './detail/StoreSettingsPage';
import GeneralTab from './detail/GeneralTab';

export default function StoreGeneral() {
	return (
		<StoreSettingsPage title='Store - General'>
			{(store, setStore) => <GeneralTab store={store} onUpdated={setStore} />}
		</StoreSettingsPage>
	);
}
